import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectChequeManagement = (state: RootState) => state.chequeMangement;

const selectIsLoading = createSelector(
  selectChequeManagement,
  (state) => state?.isLoading
);

const selectChequeList = createSelector(
  selectChequeManagement,
  (state) => state?.chequeList
);

const selectChequeDetails = createSelector(
  selectChequeManagement,
  (state) => state?.chequeDetails
);

const selectChequeListMeta = createSelector(
  selectChequeManagement,
  (state) => state?.chequeListMeta
);

const selectChequeListParams = createSelector(
  selectChequeManagement,
  (state) => state?.chequeListFilterParams
);

const selectChequeListColumn = createSelector(
  selectChequeManagement,
  (state) => state?.chequeColumn
);

export const selectors = {
  selectIsLoading,
  selectChequeList,
  selectChequeDetails,
  selectChequeListMeta,
  selectChequeListParams,
  selectChequeListColumn
};
